import { INVITETEMPLATES_UPDATE } from "../types";
import axios from "axios";
import { ENVIRONMENT_URL } from "constants/environment";

export const updateInviteTemplate = (updatedTemplate) => async (dispatch) => {
    try {
       
        const response = await axios.post(`${ENVIRONMENT_URL}/invites/invitation-template-create`, {
            bookId: updatedTemplate.bookId,
            logoUrl: updatedTemplate.logoUrl,
            description: updatedTemplate.description,
            language: updatedTemplate.language,
            htmlContent: updatedTemplate.htmlContent,
            templateType: updatedTemplate.templateType,
            approvalStatus: updatedTemplate.approvalStatus,
            approvalMessage: updatedTemplate.approvalMessage,
            ownerEmail: updatedTemplate.ownerEmail,
            ownerName: updatedTemplate.ownerName
        });


        dispatch({
            type: INVITETEMPLATES_UPDATE,
            updatedTemplate: {
                ...updatedTemplate,
                id: response.data.templateId
            }
        });

    } catch (error) {
        console.error("Error saving the template:", error);

    }
};